import { apiClient } from '../client';
import { dineEndpoints } from '../endpoints/dine.endpoints';
import { call } from './unwrap';
import type {
  BuffetBillPreviewDto,
  BuffetBillRequest,
  BuffetBillResultDto,
  BuffetBoardDto,
  BuffetMarkRequest,
  BuffetTodayDto,
} from '../types/buffet.types';

/** Buffet check-off — every answer that changes the board returns the board. */
export const buffetService = {
  today(): Promise<BuffetTodayDto> {
    return call<BuffetTodayDto>(apiClient.get(dineEndpoints.buffetToday()), "Could not read today's buffet meals");
  },
  board(meal: string): Promise<BuffetBoardDto> {
    return call<BuffetBoardDto>(apiClient.get(dineEndpoints.buffetBoard(meal)), 'Could not read the buffet board');
  },
  mark(meal: string, body: BuffetMarkRequest): Promise<BuffetBoardDto> {
    return call<BuffetBoardDto>(apiClient.post(dineEndpoints.buffetMarks(meal), body), 'Could not mark the guests');
  },
  undo(markId: string, reason: string): Promise<BuffetBoardDto> {
    return call<BuffetBoardDto>(apiClient.post(dineEndpoints.buffetUndo(markId), { reason }), 'Could not take the mark back');
  },
  close(meal: string, notes?: string): Promise<BuffetBoardDto> {
    return call<BuffetBoardDto>(apiClient.post(dineEndpoints.buffetClose(meal), { notes }), 'Could not close the counter');
  },
  /** The bill as it would be; nothing is kept (slice 3). */
  previewBill(meal: string, body: BuffetBillRequest): Promise<BuffetBillPreviewDto> {
    return call<BuffetBillPreviewDto>(apiClient.post(dineEndpoints.buffetBillPreview(meal), body), 'Could not work out the bill');
  },
  bill(meal: string, body: BuffetBillRequest): Promise<BuffetBillResultDto> {
    return call<BuffetBillResultDto>(apiClient.post(dineEndpoints.buffetBills(meal), body), 'Could not raise the bill');
  },
};
